import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Button as ButtonMUI } from '@mui/material';

export const Wrapper = styled('div')`
  display: inline-flex;

  &.fullWidth {
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const Label = styled('span')`
  text-transform: none;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Loading = styled('span')`
  position: absolute;
  margin-top: 4px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Button = styled(ButtonMUI)`
  position: relative;
  height: 38px;
  color: ${(props) =>
    props.variant === 'contained'
      ? props.color === 'white'
        ? theme.palette.secondary.main
        : theme.palette.buttonText.main
      : theme.palette[props.color].main};
  background: ${(props) => (props.variant === 'contained' ? theme.palette[props.color].main : 'transparent')};
  border: ${(props) => (props.variant === 'text' ? 'none' : `1px solid ${theme.palette[props.color].main}`)};
  padding: ${(props) => (props.variant === 'text' ? 0 : '0 1.5rem')};
  box-shadow: none;
  border-radius: 4px;

  &:hover {
    background: ${(props) => (props.variant === 'contained' ? theme.palette[props.color].focus : 'transparent')};
    box-shadow: ${(props) =>
      props.variant === 'text'
        ? 'none'
        : '0 1px 3px rgba(60, 61, 56, 0.1), 0 1px 1px rgba(60, 61, 56, 0.1), 0 2px 7px -1px rgba(60, 61, 56, 0.15)'};
  }

  .label {
    visibility: ${(props) => (props.loading ? 'hidden' : 'visible')};

    svg {
      width: ${(props) => (props.variant === 'text' ? 30 : 16)}px;
      height: ${(props) => (props.variant === 'text' ? 30 : 16)}px;
      margin: 0 4px;
    }
  }

  .loading {
    color: ${(props) => (props.variant === 'contained' ? 'white' : theme.palette[props.color].main)};
  }

  :disabled {
    border: ${(props) => (props.variant === 'text' ? 'none' : `1px solid rgba(0, 0, 0, 0.12)`)};

    .loading {
      color: black;
      opacity: 0.5;
    }
  }
`;
